import { render, staticRenderFns } from "./CaptureMedia.vue?vue&type=template&id=0f819ed2&scoped=true&"
import script from "./CaptureMedia.vue?vue&type=script&lang=js&"
export * from "./CaptureMedia.vue?vue&type=script&lang=js&"
import style0 from "./CaptureMedia.vue?vue&type=style&index=0&id=0f819ed2&prod&scoped=true&lang=css&"
import style1 from "./CaptureMedia.vue?vue&type=style&index=1&id=0f819ed2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f819ed2",
  null
  
)

export default component.exports